import { DIAGRAM_API_CONFIG, DIAGRAM_API_MODE } from './diagramApiConfig';
import { RUNTIME_API_BASE_URL } from './runtimeApi';

export const PILOT_BACKEND_VERSION = '2.0.0-cbeab6c';
export const PILOT_CONTRACT_VERSION = 'staging-secure-pilot-v1';
export const PILOT_CONSENT_VERSION = 'staging-secure-pilot-v1';
export const PILOT_AUTH_PATH = '/api/v1/auth/pilot-login';
export const PILOT_EVENT_BATCH_PATH = '/api/v1/behavior-events/batch';
export const PILOT_ERASURE_PATH = '/api/v1/behavior-events/erasure-requests';

export const PILOT_APP_VERSION =
  process.env.EXPO_PUBLIC_APP_VERSION?.trim() || '1.0.0';

export const PILOT_FEATURE_ENABLED =
  process.env.EXPO_PUBLIC_STAGING_PILOT_ENABLED === 'true' &&
  DIAGRAM_API_MODE === 'staging' &&
  DIAGRAM_API_CONFIG.baseUrl === RUNTIME_API_BASE_URL;

export const PILOT_API_BASE_URL = PILOT_FEATURE_ENABLED
  ? RUNTIME_API_BASE_URL
  : null;
